// removed by extract-text-webpack-plugin
module.exports = {"logo":"_1faXL","logoLarge":"_3p2sc","Logo":"_1mYII"};


//////////////////
// WEBPACK FOOTER
// ./src/views/components/Logo/Logo.less
// module id = 632
// module chunks = 0